define('responsive-game-feed/app/scripts/views/DataViz',['require','exports','module','../utils/Tracking','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../utils/Utils','../views/PitchesDisplay','../models/PItchModel','gameday-language/gameday-language','../utils/PitchUtils'],function(require, exports, module) {

    'use strict';
    
    var tracking = require("../utils/Tracking");
    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var Utils = require("../utils/Utils");
    var PitchesDisplay = require("../views/PitchesDisplay");
    var PitchesModel = require("../models/PItchModel");
    var gamedayLanguage = require("gameday-language/gameday-language");
    var PitchUtils = require("../utils/PitchUtils");
    
    
    /**
     * CLASS DESCRIPTION
     *
     * @param NAME {TYPE} PARAM DESCRIPTION
     * @return {TYPE} RETURN DESCRIPTION
     */
    function DataVizView(cfg) {
       this.element = cfg.element;
    }
    
    

    DataVizView.prototype = {
     
        render: function(cfg) {
            var that = this;
            var template = hogan.compile(cfg.template); 
            var model = cfg.model;
            var hasData = false;
            var pitchNum = parseInt(model.data.num_pitches);
            var pitches = model.data.pitches.map(function(pitch,index){
        		//Utils.log("pitch: " + pitch);
        		//Utils.log("index: " + index);
        		
        		var pm = new PitchesModel( pitch );
        			pm.idx = pitchNum;
        		if( pm.hasPfxData ) {
        			hasData = true;
        		}
	        	return pm;
        	});
        	
        	var hotColdData = (typeof model.data.hotColdZone !== 'undefined' && typeof model.data.hotColdZone.std !== 'undefined')  ? model.data.hotColdZone.std : undefined;
        	
            model.data['play_results'] = {};
            
            if (model.data.play_result === 'Strikeout') {
               model.data['play_results'].strikeout = true;
            }
            
            if (model.data.play_result === 'Single') {
               model.data['play_results'].single = true;
            }
            
            if (model.data.play_result === 'Double') {
               model.data['play_results'].dlb = true;
            }
            
            if (model.data.play_result === 'Triple') {
               model.data['play_results'].triple = true;
            }
            
            if (model.data.play_result === 'Homerun') {
               model.data['play_results'].homerun = true;
            }
            
            if (model.data.pitches[0].pitch_type) {
                model.data['pitch_type_mapped'] = PitchUtils.getPitchType(model.data.pitches[0].pitch_type);
            }
            
             if (model.data.pitches[0].pitcher) {
                model.data['pitcherId'] = model.data.pitches[0].pitcher;
            }
            
             if (model.data.pitches[0].pitcher) {
                model.data['pitcherId'] = model.data.pitches[0].pitcher;
            }
            
             if (model.data.pitches[0].batter) {
                model.data['batterId'] = model.data.pitches[0].batter;
            }
            
        
            
        	if( hasData ){
        	   var that = this;
		       var html = template.render({model : model, mustacheLanguage : gamedayLanguage(Utils.options.language)});
		       var strikezoneTables = $("#game-feed #strikezone table");  
                Utils.insertItem(this.element,model,html);
            
		        setTimeout(function(){
		            var pDiv = $("#"+model.guid);
		            if (pDiv.length > 0) {
		        	var pd = new PitchesDisplay(pDiv, pitches, hotColdData );
		        	pd.init();		        	
		        	
		        	strikezoneTables.css("visibility", "visible");
		        	that.element.find(".pitch-desc-container .pname a").off("click").on("click", function(e) {
                     Utils.sendPlayerMessage.call(this, {target: $(this), event:e});
                    });
		        	$(cfg.feedView).trigger("renderCBTracker_"+cfg.model.guid, cfg.model.guid);
		        	}
	                
		        }, 500);
        	}
        	
          
        }
       
   };    

    return DataVizView;;

});

